import React from 'react';

const MaintenanceMode = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>We'll Be Back Soon!</h1>
      <p style={styles.paragraph}>
        Our site is currently undergoing scheduled maintenance. 
        Thank you for your patience. Please check back later.
      </p>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    textAlign: 'center',
    backgroundColor: '#f7f7f7',
  },
  image: {
    width: '400px',
    marginBottom: '20px',
  },
  heading: {
    fontSize: '36px',
    color: '#333',
  },
  paragraph: {
    fontSize: '18px',
    color: '#666',
  },
};

export default MaintenanceMode;
